import React from 'react';
import Table from './Table';

const Payments = ({ payments }) => (
    <div className="row">
        <div className="col">
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Pagamentos</h3>
                </div>
                <div className="table-responsive">
                    <Table payments={payments} />
                </div>
            </div>
        </div>
    </div>
);

export default Payments;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Payments/index.js